import { render, staticRenderFns } from "./XProgramas.vue?vue&type=template&id=7b9c2e30"
import script from "./XProgramas.vue?vue&type=script&lang=js"
export * from "./XProgramas.vue?vue&type=script&lang=js"
import style0 from "./XProgramas.vue?vue&type=style&index=0&id=7b9c2e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports